meedy.factory('meedy.newUserRegistrationModel', ['$rootScope', 'applicationModel', 'meedy.baseModel', 'meedy.newUserRegistrationService',
    function ($rootScope, applicationModel, baseModel, newUserRegistrationService) {

        function NewUserRegistrationModel() {

            this.register = function (newUserWrapper) {
                newUserRegistrationService.register(newUserWrapper).then(
                    function (edmToken) {
                        $rootScope.$broadcast(Event.MEEDY.NEW_USER_REGISTRATION.REGISTER.SUCCESS, edmToken);
                    },
                    function (error) {
                        $rootScope.$broadcast(Event.MEEDY.NEW_USER_REGISTRATION.REGISTER.ERROR, error);

                        if (error.headers(Constant.MEEDY.ERROR_HEADER.CODE) === Enum.MEEDY.ERROR_CODE.DUPLICATED_USER_LOGIN) {
                            $rootScope.$broadcast(Event.ERROR, new ErrorVO('T.MEEDY.SYSTEM.ERROR.ERROR', 'T.MEEDY.SYSTEM.ERROR.DUPLICATED_USER_LOGIN'));
                        } else if (error.headers(Constant.MEEDY.ERROR_HEADER.CODE) === Enum.MEEDY.ERROR_CODE.DUPLICATED_USER_EMAIL) {
                            $rootScope.$broadcast(Event.ERROR, new ErrorVO('T.MEEDY.SYSTEM.ERROR.ERROR', 'T.MEEDY.SYSTEM.ERROR.DUPLICATED_USER_EMAIL'));
                        } else if (error.headers(Constant.MEEDY.ERROR_HEADER.CODE) === Enum.MEEDY.ERROR_CODE.DUPLICATED_USER_PESEL) {
                            $rootScope.$broadcast(Event.ERROR, new ErrorVO('T.MEEDY.SYSTEM.ERROR.ERROR', 'T.MEEDY.SYSTEM.ERROR.DUPLICATED_USER_PESEL'));
                        } else if (error.headers(Constant.MEEDY.ERROR_HEADER.CODE) === Enum.MEEDY.ERROR_CODE.DUPLICATED_USER_PRIMARY_PHONE) {
                            $rootScope.$broadcast(Event.ERROR, new ErrorVO('T.MEEDY.SYSTEM.ERROR.ERROR', 'T.MEEDY.SYSTEM.ERROR.DUPLICATED_USER_PRIMARY_PHONE'));
                        } else if (error.headers(Constant.MEEDY.ERROR_HEADER.CODE) === Enum.MEEDY.ERROR_CODE.DUPLICATED_PWZ) {
                            $rootScope.$broadcast(Event.ERROR, new ErrorVO('T.MEEDY.SYSTEM.ERROR.ERROR', 'T.MEEDY.SYSTEM.ERROR.DUPLICATED_PWZ'));
                        } else if (error.headers(Constant.MEEDY.ERROR_HEADER.CODE) === Enum.MEEDY.ERROR_CODE.DUPLICATED_CLINIC_NAME) {
                            $rootScope.$broadcast(Event.ERROR, new ErrorVO('T.MEEDY.SYSTEM.ERROR.ERROR', 'T.MEEDY.SYSTEM.ERROR.DUPLICATED_CLINIC_NAME'));
                        } else if (error.headers(Constant.MEEDY.ERROR_HEADER.CODE) === Enum.MEEDY.ERROR_CODE.DUPLICATED_CLINIC_REGON) {
                            $rootScope.$broadcast(Event.ERROR, new ErrorVO('T.MEEDY.SYSTEM.ERROR.ERROR', 'T.MEEDY.SYSTEM.ERROR.DUPLICATED_CLINIC_REGON'));
                        } else if (error.headers(Constant.MEEDY.ERROR_HEADER.CODE) === Enum.MEEDY.ERROR_CODE.DUPLICATED_CLINIC_NIP) {
                            $rootScope.$broadcast(Event.ERROR, new ErrorVO('T.MEEDY.SYSTEM.ERROR.ERROR', 'T.MEEDY.SYSTEM.ERROR.DUPLICATED_CLINIC_NIP'));
                        } else {
                            baseModel.broadcastOperationFailed();
                        }
                    }
                )
            };
        }

        return new NewUserRegistrationModel();
    }
]);
